export enum StorageSelectCasePackActionTypes {
  STORAGE_SET_PRODUCT_CASE_PACK_OPTIONS = "STORAGE_SET_PRODUCT_CASE_PACK_OPTIONS",
  SET_MULTIPLE_PRODUCT_CASE_PACK_OPTIONS = "SET_MULTIPLE_PRODUCT_CASE_PACK_OPTIONS",
  STORAGE_SET_SELECTED_CASE_PACK_OPTION = "STORAGE_SET_SELECTED_CASE_PACK_OPTION",
  STORAGE_SET_NEW_PRODUCT_CASE_PACK = "STORAGE_SET_NEW_PRODUCT_CASE_PACK",
  STORAGE_SET_CASE_PACK_LOADING = "STORAGE_SET_CASE_PACK_LOADING",
}
